import getColor from "@insite/mobius/utilities/getColor";
import { searchInputStyles as styles } from "@tggstore/Overrides/Widgets/Header/HeaderSearchInput";
import { colorStrings, mediaQueriesBP } from "@tggstore/Utilities/variables";
import { css } from "styled-components";

styles.searchInputStyles = {
    ...styles.searchInputStyles,
    input: {
        ...styles.searchInputStyles?.input,
        cssOverrides: {
            formField: css`
                width: 100%;

                ${mediaQueriesBP.maxLG} {
                    width: auto;
                    min-width: 50%;
                }

                ${mediaQueriesBP.minLG} {
                    min-width: max-content;
                }

                input:not(.react-datetime-picker__inputGroup__input) {
                    border: 1px solid ${getColor(colorStrings.commonGlobalGray01)};
                }
            `,
        },
    },
};
